import {
  AnalyticsEventWithControlName,
  ACTIONS,
  activity,
  eventDetailVersion,
  AnalyticsEventPropTypes
} from '@uma/react-commons/dist/index';
import { screenPath, screenName } from 'src/utils/analytics';
import { FormTypesEnum } from 'src/utils/enums';
import { URLS } from 'src/utils/urls';

export const ChangePasswordControlButtonClicked: AnalyticsEventWithControlName =
  {
    action: ACTIONS.CONTROL_BUTTON_CLICKED,
    activity,
    screenPath,
    screenName,
    controlName: 'ChangePasswordButton',
    actionAuxParams: `type=${FormTypesEnum.Password}`,
    version: eventDetailVersion
  };

export const ChangePasswordHyperLinkClicked: AnalyticsEventWithControlName = {
  action: ACTIONS.CONTROL_HYPERLINK_CLICKED,
  activity,
  screenPath,
  screenName,
  controlName: 'ChangePasswordLink',
  controlDetail: URLS.HpIdSecurity,
  version: eventDetailVersion
};

export const ManageEmailControlButtonClicked: AnalyticsEventWithControlName = {
  action: ACTIONS.CONTROL_BUTTON_CLICKED,
  activity,
  screenPath,
  screenName,
  controlName: 'ManageEmailButton',
  actionAuxParams: `type=${FormTypesEnum.Email}`,
  version: eventDetailVersion
};

export const ManageEmailHyperLinkClicked: AnalyticsEventWithControlName = {
  action: ACTIONS.CONTROL_HYPERLINK_CLICKED,
  activity,
  screenPath,
  screenName,
  controlName: 'ManageEmailLink',
  controlDetail: URLS.HpIdSecurity,
  version: eventDetailVersion
};

export const ManagePhoneControlButtonClicked: AnalyticsEventWithControlName = {
  action: ACTIONS.CONTROL_BUTTON_CLICKED,
  activity,
  screenPath,
  screenName,
  controlName: 'ManagePhoneButton',
  actionAuxParams: `type=${FormTypesEnum.Phone}`,
  version: eventDetailVersion
};

export const ManagePhoneHyperLinkClicked: AnalyticsEventWithControlName = {
  action: ACTIONS.CONTROL_HYPERLINK_CLICKED,
  activity,
  screenPath,
  screenName,
  controlName: 'ManagePhoneLink',
  controlDetail: URLS.HpIdSecurity,
  version: eventDetailVersion
};

export const ManageLoginMethodsControlButtonClicked: AnalyticsEventWithControlName =
  {
    action: ACTIONS.CONTROL_BUTTON_CLICKED,
    activity,
    screenPath,
    screenName,
    controlName: 'ManageLoginMethodsButton',
    actionAuxParams: `type=${FormTypesEnum.UserName}`,
    version: eventDetailVersion
  };

export const ManageLoginMethodsHyperLinkClicked: AnalyticsEventWithControlName =
  {
    action: ACTIONS.CONTROL_HYPERLINK_CLICKED,
    activity,
    screenPath,
    screenName,
    controlName: 'ManageLoginMethodsLink',
    controlDetail: URLS.HpIdSecurity,
    version: eventDetailVersion
  };

export const ManageTwoFactorAuthHyperlinkClicked: AnalyticsEventWithControlName =
  {
    action: ACTIONS.CONTROL_HYPERLINK_CLICKED,
    activity,
    screenPath,
    screenName,
    controlName: 'ManageTwoFactorAuthLink',
    controlDetail: URLS.HpIdSecurity,
    version: eventDetailVersion
  };

export const ManageTwoFactorAuthControlButtonClicked: AnalyticsEventWithControlName =
  {
    action: ACTIONS.CONTROL_BUTTON_CLICKED,
    activity,
    screenPath,
    screenName,
    controlName: 'ManageTwoFactorAuthButton',
    actionAuxParams: `type=${FormTypesEnum.Mfa}`,
    version: eventDetailVersion
  };

export const LoginDetailsError = (
  errorInfo: string
): AnalyticsEventPropTypes => {
  return {
    actionAuxParams: `error=${errorInfo}`,
    action: ACTIONS.MODULE_DISPLAYED,
    activity,
    screenPath,
    screenName: 'LoginDetailsError',
    version: eventDetailVersion
  };
};
